/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PricingDetailsDto
 */
export interface PricingDetailsDto {
    /**
     * Price ID from Stripe
     * @type {string}
     * @memberof PricingDetailsDto
     */
    priceId: string;
    /**
     * Amount in cents
     * @type {number}
     * @memberof PricingDetailsDto
     */
    amount: number;
    /**
     * Currency code
     * @type {string}
     * @memberof PricingDetailsDto
     */
    currency: string;
    /**
     * Billing interval
     * @type {string}
     * @memberof PricingDetailsDto
     */
    interval: string;
    /**
     * Billing interval count
     * @type {number}
     * @memberof PricingDetailsDto
     */
    intervalCount: number;
}

/**
 * Check if a given object implements the PricingDetailsDto interface.
 */
export function instanceOfPricingDetailsDto(value: object): value is PricingDetailsDto {
    if (!('priceId' in value) || value['priceId'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('interval' in value) || value['interval'] === undefined) return false;
    if (!('intervalCount' in value) || value['intervalCount'] === undefined) return false;
    return true;
}

export function PricingDetailsDtoFromJSON(json: any): PricingDetailsDto {
    return PricingDetailsDtoFromJSONTyped(json, false);
}

export function PricingDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PricingDetailsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'priceId': json['priceId'],
        'amount': json['amount'],
        'currency': json['currency'],
        'interval': json['interval'],
        'intervalCount': json['intervalCount'],
    };
}

export function PricingDetailsDtoToJSON(json: any): PricingDetailsDto {
    return PricingDetailsDtoToJSONTyped(json, false);
}

export function PricingDetailsDtoToJSONTyped(value?: PricingDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceId': value['priceId'],
        'amount': value['amount'],
        'currency': value['currency'],
        'interval': value['interval'],
        'intervalCount': value['intervalCount'],
    };
}

